module.exports = __webpack_public_path__ + "img/9791191071306.b6da47be.jpg";